// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../../../../../../../node_modules/less-loader/dist/cjs.js!./base/CampaignBadge.base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BYnCeLRj9iQFLD79hOBH {
}
.BYnCeLRj9iQFLD79hOBH[data-has-many='false'] {
  right: -15%;
}
.b7J0yTwDh6f1sn98x4_V {
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .BYnCeLRj9iQFLD79hOBH[data-has-many='false'] {
    right: -10%;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .BYnCeLRj9iQFLD79hOBH[data-has-many='false'] {
    right: -10%;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/PrizeFundCampaign/CampaignBadge/css/SingleViewCampaignBadge.module.css"],"names":[],"mappings":"AAAA;AAEA;AACA;EACE,WAAW;AACb;AACA;AAEA;AACA;AAAA;EACE;IACE,WAAW;EACb;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,WAAW;EACb;AACF;AAAA;AAAA;AAAA","sourcesContent":[".wrapper {\n  composes: wrapper from './base/CampaignBadge.base.module.css';\n}\n.wrapper[data-has-many='false'] {\n  right: -15%;\n}\n.image {\n  composes: image from './base/CampaignBadge.base.module.css';\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .wrapper[data-has-many='false'] {\n    right: -10%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `BYnCeLRj9iQFLD79hOBH ${___CSS_LOADER_ICSS_IMPORT_0___.locals["wrapper"]}`,
	"image": `b7J0yTwDh6f1sn98x4_V ${___CSS_LOADER_ICSS_IMPORT_0___.locals["image"]}`
};
export default ___CSS_LOADER_EXPORT___;
